import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Eliminar las cookies de token y userId
    Cookies.remove("token", { secure: true, sameSite: "Strict" });
    Cookies.remove("userId", { secure: true, sameSite: "Strict" });
    Cookies.remove("userName", { secure: true, sameSite: "Strict" });

    // Redirigir al usuario al login (ruta raíz)
    navigate("/", { replace: true });
  }, [navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <h3>Cerrando sesión...</h3>
    </div>
  );
};

export default Logout;
